import ConnectionCustomInput from "@ui-components/ConnectionCustomInput";
import React, {useEffect} from "react";
import {useIntl} from "react-intl";
import {CustomInputCarichiValue} from "./types";
import _ from "lodash";
import {FIELDS} from "./lib/consts";
import {ConnettoriCustomInputProps} from "../types";

export const CustomInputConnettoriCarichi = ({
  value, 
  onChange,
}: ConnettoriCustomInputProps<CustomInputCarichiValue>) => {

  // hooks
  const intl = useIntl();

  // utilities
  const update = (key: string, newValue: any, option?: boolean, removeKeys?: string[]) => {
    const v = _.omit({...(value || {}), [key]: newValue,}, removeKeys || []);
    onChange(v as CustomInputCarichiValue, option);
  }

  // initialize with default values (will be overwritten by value if exists)
  useEffect(() => {
    onChange({
      coefficienteCombinazione: 0.3,
      ...(value || {})
    } as CustomInputCarichiValue)
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return Object.entries(FIELDS).map(([key, info], idx) => (
    <ConnectionCustomInput
      key={idx}
      label={!!info.localization ? intl.formatMessage(info.localization) : info.placeholder}
      symbol={info.symbol}
      value={(value as unknown as Record<string, number> | undefined)?.[key]}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        update(key, e.target.value);
      }}
      unitOfMeasurement={info.mu}
    />
  ));
}